import { Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root',
})
export class EmailFormatterService {
	prepareQuillHtmlForEmail(quillHtml: string): string {
		if (!quillHtml) return '';
		const parser = new DOMParser();
		const doc = parser.parseFromString(quillHtml, 'text/html');
		const blocks = doc.querySelectorAll('p, div, h1, h2, h3, h4, h5, h6');
		blocks.forEach((block) => {
			const el = block as HTMLElement;
			el.style.marginTop = '0px';
			el.style.marginBottom = '0px';
			el.style.lineHeight = '1.2';
			if (el.innerHTML === '<br>' || el.innerHTML.trim() === '') {
				el.innerHTML = '&nbsp;';
				el.style.fontSize = '14px';
				el.style.lineHeight = '14px';
			}
		});
		const alignedElements = doc.querySelectorAll('[class*="ql-align-"]');
		alignedElements.forEach((node) => {
			const el = node as HTMLElement;
			if (el.classList.contains('ql-align-center')) el.style.textAlign = 'center';
			if (el.classList.contains('ql-align-right')) el.style.textAlign = 'right';
			if (el.classList.contains('ql-align-justify')) el.style.textAlign = 'justify';
			el.removeAttribute('class');
		});
		return doc.body.innerHTML;
	}
}